import React, { useState } from "react";

const ROLES = ["GE", "CE", "E"];
const ROLE_MULTI_COLLEGE = "GE"; // seul ce rôle peut être rattaché à plusieurs collèges

export function EditUserForm({ user, colleges, onCancel, onSave }) {
  const [form, setForm] = useState({
    comIds: (user.comIds ?? []).map(String),
    utcRole: user.utcRole ?? "",
    utcActif: user.utcActif,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const isMultiCollege = form.utcRole === ROLE_MULTI_COLLEGE;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => {
      if (name === "utcActif") return { ...f, utcActif: value === "true" };
      if (name === "utcRole") {
        // CE/E ne peuvent garder qu'un seul collège : on tronque au besoin.
        const comIds = value !== ROLE_MULTI_COLLEGE ? f.comIds.slice(0, 1) : f.comIds;
        return { ...f, utcRole: value, comIds };
      }
      return { ...f, [name]: value };
    });
  };

  const toggleCollege = (comId) => {
    const id = String(comId);
    setForm((f) => ({
      ...f,
      comIds: f.comIds.includes(id) ? f.comIds.filter((v) => v !== id) : [...f.comIds, id],
    }));
  };

  const selectSingleCollege = (value) => {
    setForm((f) => ({ ...f, comIds: value ? [value] : [] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await onSave(user.utcId, {
        comIds: form.comIds.map(Number),
        utcRole: form.utcRole,
        utcActif: form.utcActif,
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-3 border bg-dark">
      <div className="pb-3" style={{color:"white"}}>
        <div className="row pb-2">
          <div className="col-6">
            <label className="form-label">
              <strong>{isMultiCollege ? "Collège(s)" : "Collège"}</strong>
              {!isMultiCollege && (
                <span className="text-secondary ms-1" style={{ fontWeight: "normal" }}>
                  (plusieurs collèges réservé au rôle GE)
                </span>
              )}
            </label>
            {isMultiCollege ? (
              <div className="form-control" style={{ height: "auto", maxHeight: 160, overflowY: "auto" }}>
                {colleges.map((c) => (
                  <div className="form-check" key={c.comId}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`college-${c.comId}`}
                      checked={form.comIds.includes(String(c.comId))}
                      onChange={() => toggleCollege(c.comId)}
                    />
                    <label className="form-check-label" htmlFor={`college-${c.comId}`}>
                      {c.comLib}
                    </label>
                  </div>
                ))}
              </div>
            ) : (
              <select
                className="form-control"
                value={form.comIds[0] || ""}
                onChange={(e) => selectSingleCollege(e.target.value)}
              >
                <option value="">—</option>
                {colleges.map((c) => (
                  <option key={c.comId} value={c.comId}>{c.comLib}</option>
                ))}
              </select>
            )}
          </div>
          <div className="col-3">
            <label className="form-label"><strong>Rôle</strong></label>
            <select name="utcRole" value={form.utcRole} onChange={handleChange} className="form-control">
              <option value="" disabled>Choisir...</option>
              {ROLES.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
          <div className="col-3">
            <label className="form-label"><strong>État</strong></label>
            <select name="utcActif" value={String(form.utcActif)} onChange={handleChange} className="form-control">
              <option value="true">Actif</option>
              <option value="false">Inactif</option>
            </select>
          </div>
        </div>
        {error && <div className="text-danger">{error}</div>}
      </div>
      <button type="submit" className="btn fr-btn me-2" disabled={saving}>
        {saving ? "Enregistrement…" : "Enregistrer"}
      </button>
      <button type="button" className="btn fr-btn fr-btn--secondary" onClick={onCancel} disabled={saving}>
        Annuler
      </button>
    </form>
  );
}
